<!--
 * @author yanshangfei
 * @date 2024-01-25 17:11
 * @description  下载中心
-->
<template>
  <div>
    <div ref="dowPage">
      <div class="downPage beauty-scroll">
        <div class="title">
          <div class="title-name">下载清单</div>
        </div>
        <p class="tip">
          <span class="icon">!</span>执行成功的报表文件系统会保留15天，过期将自动删除文件，请及时进行下载。
        </p>
      </div>
    </div>
    <lsTableLayout>
      <div slot="table">
        <ls-api-table ref="dataTable" :columns="columns" :tableProps="tableProps" :scroll="{ fixScreen: true }">
          <!-- 状态 -->
          <template slot="taskStatus" slot-scope="data">
            {{ FILE_STATUS[data.record.taskStatus] }}
          </template>
          <!-- 操作 -->
          <template slot="edit" slot-scope="data">
            <a
              @click="downLoad(data.record.downloadUrl)"
              href="javascript:;"
              :disabled="data.record.taskStatus != 25"
              v-if="!data.record.loading"
            >下载
            </a>
            <span v-if="data.record.loading">下载中 </span>
          </template>
          <!-- 创建时间 -->
          <template slot="dataCreateTime" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm') }}
          </template>
          <!-- 开始处理时间 -->
          <template slot="dealTime" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm') }}
          </template>
          <!-- 完成处理时间 -->
          <template slot="finishTime" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm') }}
          </template>
          <!-- 处理耗时 -->
          <template slot="detailTime" slot-scope="data">
            {{ getTimer(data) }}
          </template>
        </ls-api-table>
      </div>
    </lsTableLayout>
  </div>
</template>

<script>
import { FILE_STATUS } from './enum.js'
import { apiGetList } from '@/api/download/download.js'
import { generateLsTableResDataPageRowsVersion } from '@/utils/util.js';

export default {
  // eslint-disable-next-line
  name: 'download',
  components: {},
  data () {
    return {
      FILE_STATUS,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResDataPageRowsVersion(apiGetList, true),
        pageCurrent: false
      },
      // 表头
      columns: [
        {
          title: '名称',
          dataIndex: 'taskName',
          width: 150
        },
        {
          dataIndex: 'taskDesc',
          title: '描述',
          ellipsis: true,
          width: 300
        },
        {
          dataIndex: 'dataCreateTime',
          title: '创建时间',
          scopedSlots: { customRender: 'dataCreateTime' },
          width: 150
        },
        {
          dataIndex: 'dealTime',
          title: '开始处理时间',
          scopedSlots: { customRender: 'dealTime' },
          width: 150
        },
        {
          dataIndex: 'finishTime',
          title: '完成处理时间',
          scopedSlots: { customRender: 'finishTime' },
          width: 150
        },
        {
          dataIndex: 'detailTime',
          title: '处理耗时',
          scopedSlots: { customRender: 'detailTime' }
        },
        {
          dataIndex: 'taskStatus',
          title: '任务状态',
          scopedSlots: { customRender: 'taskStatus' }
        },
        {
          dataIndex: 'result',
          title: '原因',
          ellipsis: true,
          width: 300
        },
        {
          dataIndex: 'edit',
          title: '操作',
          scopedSlots: { customRender: 'edit' },
          with: 60
        }
      ],
      // table加载绑定
      tableLoading: false,
      // 表格数据
      roleList: []
    }
  },
  mounted () {
    this.onSearch() // 添加多一次初始化搜索，避免进页面空白
  },
  activated () {
    this.onSearch()
    this.setTimeServer = window.setInterval(() => {
      this.onSearch()
    }, 7000)
  },
  deactivated () {
    if (this.setTimeServer) {
      window.clearInterval(this.setTimeServer)
      this.setTimeServer = null
    }
  },
  beforeDestroy () {
    if (this.setTimeServer) {
      window.clearInterval(this.setTimeServer)
      this.setTimeServer = null
    }
  },
  methods: {
    // 表单搜索
    onSearch () {
      this.$refs.dataTable.SearchData()
    },
    /**
     * @name:
     * @description: 下载文件
     */
    downLoad (path) {
      const link = document.createElement('a')
      link.href = location.protocol + path.split(':')[1]
      const name = path.substring(path.lastIndexOf('/') + 1)
      link.download = name
      document.body.appendChild(link)
      link.click()
      window.URL.revokeObjectURL(link.href)
      document.body.removeChild(link)
    },
    // 显示时间
    getTimer (data) {
      const record = data.record
      if (record.dealTime && record.finishTime) {
        const diffValue = this.$moment(record.finishTime).diff(record.dealTime)
        const value = diffValue / 1000
        if (value < 60) {
          return `${value}秒`
        } else if (value < 3600) {
          const m = parseInt(value / 60)
          const s = parseInt(value - 60 * m)
          return `${m}分${s}秒`
        } else {
          const h = parseInt(value / 3600)
          const m = parseInt((value - 3600 * h) / 60)
          const s = parseInt(value - 3600 * h - 60 * m)
          return `${h}时${m}分${s}秒`
        }
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped lang="less">
.over-text {
  overflow: hidden;
  text-overflow: ellipsis;
}
.downPage {
  background-color: white;
  overflow-y: auto;
  height: 100%;
  //height: 100vh;
  .title {
    text-align: center;
    border-bottom: 1px solid #f0f0f0;
    padding: 10px 30px;
    display: flex;
    justify-content: space-between;
  }
  .tip {
    padding: 10px 30px;
    background-color: #f0f0f0;
    color: #888888;
    font-size: 13px;
  }
  .btn {
    background-color: #1ab192;
    padding: 0 20px;
    height: 30px;
    line-height: 30px;
    color: #f0f0f0;
    letter-spacing: 2px;
    font-size: 13px;
    border-radius: 3px;
    cursor: pointer;
    &:hover {
      background-color: #0f9579;
    }
  }
  .title-name {
    letter-spacing: 2px;
    color: black;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
  }
  .icon {
    border-radius: 100px;
    border: 1px solid #00a7d0;
    text-align: center;
    display: block;
    float: left;
    width: 16px;
    height: 16px;
    line-height: 16px;
    color: #00a7d0;
    margin-right: 7px;
  }

  .block {
    text-align: right;
  }
  /deep/ .cell {
    padding: 0 30px;
  }
  /deep/ .el-table__cell > .cell {
    padding-left: 30px;
  }
}
</style>
